import { ReactNode } from 'react';
import { Box } from '@/components/Box/Box';
import { Button } from '@/components/Button/Button';
import { FormikInput } from '@/components/form/fields/FormikInput/FormikInput';
import { ResponseErrorType } from '@/types/sharedTypes';
import { ERROR_MESSAGE_HEIGHT } from '@/components/form/fields/InputError/styles';

type UserEmailInputType = {
  name?: string;
  notification?: ReactNode;
  isLoading?: boolean;
  labelHint?: ReactNode;
  error?: string;
  apiError?: ResponseErrorType;
  onSubmit: () => void;
  disabled?: boolean;
};

const INPUT_HEIGHT = 50;
const BUTTON_HEIGHT = 40;

const getButtonWrapperBottomPosition = () => {
  return ERROR_MESSAGE_HEIGHT + (INPUT_HEIGHT - BUTTON_HEIGHT) / 2;
};

export const UserEmailInput = ({
  name = 'email',
  notification,
  isLoading,
  labelHint,
  error,
  apiError,
  onSubmit,
  disabled,
}: UserEmailInputType) => {
  const showNotifications = !error && !apiError && notification;
  const bottomPosition = getButtonWrapperBottomPosition();

  return (
    <>
      <Box display='flex' alignItems='center' columnGap='6px' position='relative'>
        <FormikInput
          name={name}
          label='Email Address*'
          labelHint={labelHint}
          placeholder='Enter or Select Email Address'
          apiError={apiError}
          disabled={disabled}
          overlaySlot={
            <Box
              display='flex'
              alignItems='center'
              columnGap='8px'
              position='absolute'
              right='5px'
              bottom={`${bottomPosition}px`}
            >
              <Button
                variant='primary'
                size='medium'
                width='auto'
                onClick={onSubmit}
                type='button'
                disabled={!!notification || disabled}
                isLoading={isLoading}
              >
                Submit email
              </Button>
            </Box>
          }
        />
      </Box>
      {showNotifications && <Box>{notification}</Box>}
    </>
  );
};
